export const tourRoles = [
    "TOUR_MEMBER",
    "TOUR_MANAGER",
    "TOUR_OWNER",
    "VENDOR",
    "TOUR_LEAD",
];
export const TourRoles = {
    TOUR_MEMBER: "TOUR_MEMBER",
    TOUR_MANAGER: "TOUR_MANAGER",
    TOUR_OWNER: "TOUR_OWNER",
    VENDOR: "VENDOR",
    TOUR_LEAD: "TOUR_LEAD",
};
export const tourRolesOptions = tourRoles.map((role) => ({
    label: role,
    value: role,
}));
export const tourRoleTitles = [
    "BACKSTAGE_MANAGER",
    "BACKLINE_TECH",
    "FOH",
    "HOSPITALITY_COORDINATOR",
    "MON",
    "PERSONAL_SECURITY",
    "PRODUCTION_COORDINATOR",
    "SHOW_CALLER",
    "STAGE_MANAGER",
    "TOUR_COORDINATOR",
    "VENUE_SECURITY",
    "VIDEO_DIRECTOR",
];
export const TourRoleTitles = {
    BACKSTAGE_MANAGER: "BACKSTAGE_MANAGER",
    BACKLINE_TECH: "BACKLINE_TECH",
    FOH: "FOH",
    HOSPITALITY_COORDINATOR: "HOSPITALITY_COORDINATOR",
    MON: "MON",
    PERSONAL_SECURITY: "PERSONAL_SECURITY",
    PRODUCTION_COORDINATOR: "PRODUCTION_COORDINATOR",
    SHOW_CALLER: "SHOW_CALLER",
    STAGE_MANAGER: "STAGE_MANAGER",
    TOUR_COORDINATOR: "TOUR_COORDINATOR",
    VENUE_SECURITY: "VENUE_SECURITY",
    VIDEO_DIRECTOR: "VIDEO_DIRECTOR",
};
export const tourRoleTitlesOptions = tourRoleTitles.map((role) => ({
    label: role,
    value: role,
}));
export const tourEventTypes = [
    "TRAVEL",
    "HOTEL_STAY",
    "SHOW",
    "REHEARSAL",
    "PRODUCTION",
    "PROMO",
    "GLAM",
    "LOAD_IN",
    "SCHEDULE_ITEM",
    "MEALS",
    "DOORS",
    "LOBBY_CALL",
    "SHOW_CALL",
    "PRODUCTION_CALL",
    "VENUE_CALL",
];
export const TourEventTypes = {
    TRAVEL: "TRAVEL",
    HOTEL_STAY: "HOTEL_STAY",
    SHOW: "SHOW",
    REHEARSAL: "REHEARSAL",
    PRODUCTION: "PRODUCTION",
    PROMO: "PROMO",
    GLAM: "GLAM",
    LOAD_IN: "LOAD_IN",
    SCHEDULE_ITEM: "SCHEDULE_ITEM",
    MEALS: "MEALS",
    DOORS: "DOORS",
    LOBBY_CALL: "LOBBY_CALL",
    SHOW_CALL: "SHOW_CALL",
    PRODUCTION_CALL: "PRODUCTION_CALL",
    VENUE_CALL: "VENUE_CALL",
};
export const personalEventName = "PERSONAL";
export const tourDayTags = [
    "TRAVEL_DAY",
    "HOTEL_STAY",
    "SHOW_DAY",
    "REHEARSAL_DAY",
    "PRODUCTION_DAY",
    "PROMO_DAY",
    "GLAM_DAY",
    "LOAD_IN_DAY",
    "OFF_DAY",
    "STUDIO_DAY",
    "MEALS",
    "DOORS",
    "LOBBY_CALL",
    "SHOW_CALL",
    "PRODUCTION_CALL",
    "VENUE_CALL",
];
export const TourDayTags = {
    TRAVEL_DAY: "Travel day",
    REHEARSAL_DAY: "Rehearsal day",
    GLAM_DAY: "Glam day",
    HOTEL_STAY: "Accommodation",
    LOAD_IN_DAY: "Load-in day",
    PRODUCTION_DAY: "Production day",
    PROMO_DAY: "Promo day",
    SHOW_DAY: "Show day",
    OFF_DAY: "Off day",
    STUDIO_DAY: "Studio day",
    MEALS: "Meals",
    DOORS: "Doors",
    LOBBY_CALL: "Lobby call",
    SHOW_CALL: "Show call",
    PRODUCTION_CALL: "Production call",
    VENUE_CALL: "Venue call",
};
export const tourEventRoles = ["CREW", "SPECTATOR"];
export const TourEventRoles = {
    CREW: "CREW",
    SPECTATOR: "SPECTATOR",
};
/**
 * Single source of truth for which archive actions a user can see for a tour.
 * Shared by web and mobile so the menu gating can't drift between platforms.
 *
 * Rules:
 * - TOUR_OWNER archives globally (never "for me"); requires an active
 *   subscription. Unarchiving globally additionally requires the artist to
 *   not be archived (mirrors the backend's `unarchiveGlobally` guard).
 * - Any other member archives only "for me" (no subscription required), but
 *   only while the tour is not already archived globally.
 * - "Unarchive for me" intentionally has no owner exclusion: a member who
 *   personally archived a tour and was later promoted to TOUR_OWNER must
 *   still be able to clear the stale personal flag.
 * - "Unarchive for me" is unavailable while the tour is archived globally:
 *   clearing your own personal flag would not restore your visibility (the
 *   owner's global archive still hides it), so offering the action would be
 *   misleading. Only the owner's "Unarchive" can bring it back for everyone.
 * - `canOpenArchiveMenu` is derived from the four actions above, so it can
 *   never render an empty menu.
 */
export const getAvailableTourArchiveActions = ({ isOwner, isSubscriptionActive, archived, personallyArchived, isArtistArchived = false, }) => {
    const canArchive = isOwner && isSubscriptionActive && !archived;
    const canUnarchive = isOwner && isSubscriptionActive && archived && !isArtistArchived;
    const canArchiveForMe = !isOwner && !archived && !personallyArchived;
    const canUnarchiveForMe = personallyArchived && !archived;
    return {
        canArchive,
        canUnarchive,
        canArchiveForMe,
        canUnarchiveForMe,
        canOpenArchiveMenu: canArchive || canUnarchive || canArchiveForMe || canUnarchiveForMe,
    };
};
